<template>
  <div>
	<!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Edit Role</strong>
          </CCardHeader>
          <CCardBody>
			<CForm id="formData">
            <CRow>
				<CCol sm="12">
                <CInput
                  label="Name"
                  placeholder="Name"
				  name="Role_Name"
				  id="Role_Name"
                />
              </CCol>
            </CRow>
            <!-- <CRow>
                <template v-for="(name, key) in checkboxNames">
                <CRow sm="12" form class="form-group" :key="name">
                  <CCol tag="label" sm="3" class="col-form-label">
                    {{name}}
                  </CCol>
                  <CCol sm="9" :class="key % 2 === 1 ? 'form-inline' : ''">
                    <CInputCheckbox
                      v-for="(option, optionIndex) in options"
                      :key="key + option"
                      :label="option"
                      :value="option"
                      :custom="key > 1"
                      :name="`Option 1${key}`"
                      :checked="optionIndex === key"
                      :inline="key % 2 === 1"
                    />
                  </CCol>
                </CRow>
              </template>
            </CRow> -->
           
            <CRow>
			<CCol sm="6">
				<button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-light btn-block active fw-500 col-white fs-18" @click="back()">Cancel</button>
              </CCol>
              <CCol sm="6">
                <button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-info btn-block active fw-500 col-white fs-18" @click="submit()">Update</button>
                <CInput hidden name="Status"/>
			</CCol>
			 
            </CRow>
			</CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
//import { ModelSelect } from 'vue-search-select';
import axios from "axios";
export default {
  name: 'Edit_roles',
  data () {
    return {
      isLoading: false,
      setSelected:"",
      selected: [], // Must be an array reference!
      show: true,
      horizontal: { label:'col-3', input:'col-9' },      
	  siteOptions : [],
      physicalOptions : ['New physical','LIQUID'],
      customerOptions: [],
      wasteqty: ['1.0', '2.0', '3.0', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0'],
      wasteshipment: [],
      wastepackaging: [],
      wastetexture: [],
      wastetrucktype: [],
      wastename: [],	
	  oldest_os_amt:0,
	  oldest_days:0,
	  invoice_number:0,
	  outstanding_amt:0,
	  
      formCollapsed: true,
      checkboxNames: ['Change Status'],
	  options: ['role-list', 'role-create', 'role-edit', 'role-delete', 'deshboard-transactions-chart'],
      radioNames: ['Radios', 'Inline Radios',
                    'Radios - custom', 'Inline Radios - custom'],			
    }
  },
  mounted () {
	$('.counterDiv').hide();
  $('.otherOptions').hide();	
  var edit_id=localStorage.getItem("edit_id");
	var token=localStorage.getItem("auth");
  var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
  
  var requestInfo = {
		Role_Id: edit_id,		
		Token:token,
		Session_User_Id:Session_User_Id,
		};
		//console.log(requestInfo);
		var data = JSON.stringify(requestInfo);				
			var self = this;
			var config = {
			  method: 'post',
			  url: apiURL+'ManageRole/GetRolesDetails',
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
		};
    this.isLoading = true;
		axios(config)
		.then((result) => {	
      this.isLoading = false;		
			if(result.data.status_code==200){
				var obj=result.data.response;
				//console.log(obj[0]);
        $('input[name=Role_Id]').val(obj[0].Role_Id);
        $('input[name=Role_Name]').val(obj[0].RoleName);
				$('input[name=Status]').val(obj[0].Status);				
				//$('#reponse_error').html(result.data.message);
			}else{				
				//$('#reponse_error').html(result.data.message);
				this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: result.data.message		 
				})
			}
		  
		})
		.catch((error) => {
      this.isLoading = false;
			//var errorObject=JSON.stringify(error.response.data.errors);			
			//console.log(errorObject);		   
			this.$swal.fire({
			  icon: 'error',
			  title: 'Oops...',
			  text: 'Something went wrong!'		 
			})
		});
  },
  computed: {
        
   },
  methods: {
    validator (val) {
      return val ? val.length >= 4 : false
    },
	back(){
		console.log('call');
		this.$router.push({path:'role_lists'})
	},
	submit(){
    var Role_Name = $('#Role_Name').val();
		// console.log(Role_Name);
    if(Role_Name==''){
			this.$swal('Role Name is required');
			return false;
    }
    
    var Role_Id=JSON.parse(localStorage.getItem("edit_id"));
    var user=JSON.parse(localStorage.getItem("user"));
		var FirstName=user[0].FirstName;		
		var LastName=user[0].LastName;
    var Status = $('input[name=Status]').val();
    var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
    var token=localStorage.getItem("auth");	
    
    var requestInfo = {
      Role_Id: Role_Id,
      RoleName: Role_Name,
      GuardName: FirstName+' '+LastName,
      Status: Status,
      Token:token,
      Session_User_Id:Session_User_Id,
    };
    console.log(requestInfo);
    
    var self =this;
    var data = JSON.stringify(requestInfo);								
				var config = {
				  method: 'post',
				  url: apiURL+'ManageRole/UpdateUserRole',
				  headers: { 
					'Content-Type': 'application/json'
				  },
				  data : data
      };
      console.log(data);
      this.isLoading = true;
			axios(config)
			.then((result) => {	
        this.isLoading = false;		
				if(result.data.status_code==200){			
          this.$swal.fire({
              icon: 'success',
							title: "Saved", 
							text: result.data.message, 
							type: "success"					  
						}).then(function(){ 
						    this.$router.push({path:'role_lists'})
						   }
						);						
				}else{				
					//$('#reponse_error').html(result.data.message);
					this.$swal.fire({
					  icon: 'error',
					  title: 'Oops...',
					  text: result.data.message		 
					})
				}
			  
			})
			.catch((error) => {
        this.isLoading = false;	
				//var errorObject=JSON.stringify(error.response.data.errors);			
				//console.log(errorObject);		   
				this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: 'Something went wrong!'		 
				})
			});
	}
  }
}
</script>
